import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "items-list",
  class: "flex flex-col gap-5"
}
const _hoisted_2 = {
  id: "actions",
  class: "flex justify-between items-center gap-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, /*#__PURE__*/_toDisplayString("Items*"), -1)
const _hoisted_4 = {
  id: "items",
  class: "mt-5"
}
const _hoisted_5 = {
  id: "info-items",
  class: "flex justify-between items-center gap-3 bg-h-neutral-200 p-5 shadow rounded font-bold"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, /*#__PURE__*/_toDisplayString("Items criados"), -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-2xl text-center w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_ItemCard = _resolveComponent("ItemCard")!
  const _component_FormItems = _resolveComponent("FormItems")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            label: "Criar Item",
            class: "btn-outline",
            onClick: _withModifiers(_ctx.openDialog, ["prevent"])
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", {
          class: _normalizeClass([
            { 'text-h-error-600': _ctx.items.length === 0 },
            { 'text-h-warning-600': _ctx.items.length >= 1 && _ctx.items.length < 3 },
            { 'text-h-success-600': _ctx.items.length >= 3 },
          ])
        }, _toDisplayString(_ctx.items?.length) + " " + _toDisplayString(" / 5 itens"), 3)
      ]),
      (_ctx.items?.length === 0)
        ? (_openBlock(), _createBlock(_component_EmptyData, {
            key: 0,
            data: _ctx.items?.length === 0,
            label: _ctx.emptyStateItems.description,
            image: _ctx.emptyStateItems.image,
            imgSize: "h-40 my-10",
            msgSize: "lg:w-[350px] -mt-14"
          }, null, 8, ["data", "label", "image"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_ItemCard, {
                  item: item,
                  "item-index": index,
                  onEditItem: _ctx.onEditItems
                }, null, 8, ["item", "item-index", "onEditItem"])
              ]))
            }), 128))
          ]))
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.open,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '45vw' },
      modal: true,
      draggable: false,
      onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog()))
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", { pt: "Criar Item", en: "Create Item" })), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_FormItems, {
          onOnClose: _ctx.closeDialog,
          isEditing: _ctx.isEditing.items
        }, null, 8, ["onOnClose", "isEditing"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}